import React, { useEffect } from "react";
import { components } from "../components";

type Props = {
  open: boolean;
  maxHeight: string;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  disabled?: boolean;
  closeButton?: boolean
};

export const BottomSheet: React.FC<Props> = ({
  open,
  maxHeight,
  onClose,
  title,
  children,
  disabled = false,
  closeButton = false
}) => {
  useEffect(() => {
    // const handleKey = (e: KeyboardEvent) => {
    //   if (e.key === "Escape") onClose();
    // };
    // document.addEventListener("keydown", handleKey);
    // return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <>
      {/* Overlay */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          opacity: open ? 1 : 0,
          visibility: open ? "visible" : "hidden",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          zIndex: 1000,
        }}
      />

      {/* Bottom Sheet */}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          transform: open ? "translateY(0)" : "translateY(100%)",
          transition: "transform 0.3s ease",
          zIndex: 1001,
          maxWidth: '650px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <div
          style={{
            background: "var(--main-background)",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            maxHeight: maxHeight,
            minHeight: "60vh",
            paddingTop: "16px",
            overflowY: "auto",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
          }}
        >
          {/* Handle bar */}
          <div
            style={{
              width: "40px",
              height: "5px",
              background: "#ccc",
              borderRadius: "3px",
              margin: "0 auto 12px auto",
            }}
          />

          {/* Header */}
          {title && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
                paddingLeft: "16px", paddingRight: "16px"
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                {title}
              </h4>
              {closeButton && <button
                onClick={onClose}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                ✕
              </button>}
            </div>
          )}
          <div style={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: "#e6e3e3ff",
            borderRadius: 2,
          }}></div>
          <div style={{
            fontSize: "16px", lineHeight: 1.5, paddingLeft: "16px", paddingRight: "16px"
          }}>{children}</div>
        </div>
      </div>
    </>
  );
};
